<template>
  <div v-tooltip="{
    content: tooltipContent,
    delay: {
      show: 100,
      hide: 100
    }
  }">
    <template v-if="customsHandler === 'kgh'">KGH</template>

    <template v-else-if="customsHandler !== 'none'">
      <div
        class="flex items-center justify-center py-1 text-base text-white rounded-full h-7 w-7"
        :class="{
          'bg-red-500': customsStatus === '',
          'bg-orange-500': customsStatus === 'pending',
          'bg-green-500': customsStatus === 'done'
        }"
      >
        <FontAwesomeIcon :icon="['far', 'stamp']" />
      </div>
    </template>

    <template v-else-if="shoCustomsStamp">
      <div>{{ $tk("Common.Order.Customs").toUpperCase() }}</div>
    </template>
  </div>
</template>

<script>
import { get } from "lodash"

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    shoCustomsStamp() {
      return get(this.item, "showCustomsStamp", false)
    },
    customsHandler() {
      return get(this.item, "customsHandler", "")
    },
    customsStatus() {
      return get(this.item, "customsStatus", "")
    },
    tooltipContent() {
      return this.customsHandler === 'kgh' ? this.$t("PDisplayCustomsClearance.KGH") :
        this.customsHandler === 'self' ? this.$t("PDisplayCustomsClearance.SelfDeclared") :
          this.customsHandler === 'required' ? this.$t("PDisplayCustomsClearance.RequiresDeclaration") : ""
    }
  }
}
</script>
